import {create} from 'zustand';
import {DocumentData, DocumentSnapshot} from 'firebase/firestore';

type UsersStore = {
	users: DocumentSnapshot<DocumentData, DocumentData>[] | null;
	setUsers: (
		newUsers: DocumentSnapshot<DocumentData, DocumentData>[] | null,
	) => void;

	lastVisibleUser: DocumentSnapshot<DocumentData, DocumentData> | null;
	setLastVisibleUser: (
		newLastVisibleUser: DocumentSnapshot<DocumentData, DocumentData> | null,
	) => void;

	loadedAllUsers: boolean;
	setLoadedAllUsers: (loadedAllUsers: boolean) => void;
};

export const useUsersStore = create<UsersStore>((set) => ({
	users: null,
	setUsers: (
		newUsers: DocumentSnapshot<DocumentData, DocumentData>[] | null,
	) => {
		set(() => ({users: newUsers}));
	},

	lastVisibleUser: null,
	setLastVisibleUser: (
		newLastVisibleUser: DocumentSnapshot<DocumentData, DocumentData> | null,
	) => {
		set(() => ({lastVisibleUser: newLastVisibleUser}));
	},

	loadedAllUsers: false,
	setLoadedAllUsers: (newLoadedAllUsers: boolean) => {
		set(() => ({loadedAllUsers: newLoadedAllUsers}));
	},
}));
